(() => {
  if (window.htPwcGalleryBound) return;
  const config = document.getElementById('ht-pwc-gallery-map');
  if (!config) return;
  const media = JSON.parse(config.textContent).media;
  const mappings = new Map();
  const normalize = value => (value || '').trim().toLowerCase();
  media.forEach(item => {
    const parts = (item.alt || '').split('|').map(normalize);
    if (parts.length === 4 && parts[0] === 'pwc sheet') {
      mappings.set(parts.slice(1).join('|'), item);
    }
    if (item.url.includes('/hydroturf-pwc-sheet-black-flat-left-1600')) {
      mappings.set('flat|solid color|black', item);
    }
  });
  if (!mappings.size) return;
  window.htPwcGalleryBound = true;
  let revision = 0;
  let activeKey;
  const selection = (root, label) => {
    const box = Array.from(root.querySelectorAll('.ymq-options-box'))
      .find(box => box.dataset.label === label && box.getClientRects().length);
    return box ? box.querySelector('input[type="radio"]:checked')?.value : null;
  };
  const synchronize = () => {
    const root = document.querySelector('[data-product-id="8044372394285"]')?.closest('.product-detail');
    if (!root) return;
    const style = selection(root, 'Style');
    const type = selection(root, 'Type');
    const colorBox = Array.from(root.querySelectorAll('.ymq-options-box'))
      .find(box => (box.dataset.label || '').startsWith('Color (') && box.getClientRects().length);
    const color = colorBox?.querySelector('input[type="radio"]:checked')?.value;
    const key = [style, type, color].map(normalize).join('|');
    if (activeKey === key) return;
    const match = mappings.get(key);
    const fallback = media.find(item => !Array.from(mappings.values()).some(mapped => mapped.id === item.id));
    const target = match || fallback;
    if (!target) return;
    const slideshow = root.querySelector('.gallery .product-slideshow');
    const slide = slideshow?.querySelector('.slide[data-media-id="' + target.id + '"]:not(.slick-cloned)');
    if (slideshow?.slick && slide) {
      slideshow.slick.slickGoTo(Number(slide.dataset.slickIndex), true);
      activeKey = key;
      return;
    }
    const thumbnail = root.querySelector('.gallery .thumbnail[data-media-id="' + target.id + '"]');
    if (!thumbnail) return;
    thumbnail.addEventListener('click', event => event.preventDefault(), {once: true});
    thumbnail.click();
    activeKey = key;
  };
  const schedule = () => {
    const current = ++revision;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (current === revision) synchronize();
    }));
  };
  document.addEventListener('change', event => {
    if (event.target.closest('.ymq-options-box')) schedule();
  });
  document.addEventListener('click', event => {
    if (event.target.closest('.ymq-canvas-box, .ymq-options-button-label')) schedule();
  });
  const observeOptions = () => {
    const root = document.querySelector('[data-product-id="8044372394285"]')?.closest('.product-detail');
    if (!root) return;
    const observer = new MutationObserver(schedule);
    observer.observe(root.querySelector('.detail'), {childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'checked']});
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeOptions, {once: true});
  else observeOptions();
})();

